import { GridButtons } from "@/controls/buttons/GridButtons";
import { Chock } from "@/pages/catalogs/models/Chock";
import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import { ColDef, ICellRendererParams } from "ag-grid-enterprise";

type Props = {
	setSelectedRowData: (chock: Chock) => void;
	setShowModal: (modal: "create" | "update" | "delete" | "") => void;
	showContextMenu: Function;
};
export const useTableData = ({
	setSelectedRowData,
	setShowModal,
	showContextMenu,
}: Props) => {
	const columnDefs: ColDef[] = [
		// Hide
		{
			field: "RFIDTag",
			headerName: "Tag",
			minWidth: 20,
			hide: true,
			flex: 1,
		},
		{
			field: "LocationName",
			headerName: "Location",
			hide: true,
			minWidth: 20,
			flex: 1,
		},
		// Visible
		{
			field: "PartName",
			headerName: "Name",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "RebuildTimestamp",
			headerName: "Rebuild Date",
			minWidth: 20,
			flex: 1,
			valueGetter: (params) =>
				dxtToLocalServerTime(
					(params.data as Chock)?.RebuildTimestamp,
					"MM/dd/yy",
				) || "",
		},
		{
			field: "BearingChangeTimestamp",
			headerName: "Bearing Change Date",
			minWidth: 20,
			flex: 1,
			valueGetter: (params) =>
				dxtToLocalServerTime(
					(params.data as Chock)?.BearingChangeTimestamp,
					"MM/dd/yy",
				) || "",
		},
		{
			field: "-",
			cellRenderer: GridButtons,
			cellRendererParams: (params: ICellRendererParams) => ({
				setId: setSelectedRowData,
				id: params.data as Chock,
				edit: false,
				setShowModal: setShowModal,
				showContextMenu: () =>
					showContextMenu(event, params.data, "chockContext"),
			}),
			wrapText: false,
			autoHeight: false,
			wrapHeaderText: false,
			headerName: "",
			flex: 1,
			maxWidth: 180,
			autoHeaderHeight: true,
		},
	];
	return { columnDefs };
};
